import { /*Typeahead,*/ Bloodhound } from '../vendors/typeahead/typeahead';

window.Bloodhound = Bloodhound;

const init_top_search = (() => {
	const $searchBox = $('#top-search-box');
	
	if(! $searchBox.length) {
		//console.log('TopSearch: search input not found');
		return false;
	}

	if(typeof(Bloodhound) == 'undefined') {
		console.log('TopSearch: Bloodhound engine is missing');
		return false;
	}

	const $form = $searchBox.closest('form'),
		$wrapper = $form.closest('.product-search'),
		$holder = $form.find('.field').first(),
		focusClass = 'focus';
		
	let _selected = null;

	const template_r = ''+
		'<div class="a-tasearch-result">'+
			'<a href="{{url}}" class="a-tasearch-result-clicktag">'+
				'<span class="title">{{title}}</span>'+
				'<span class="desc">{{type}}</span>'+
			'</a>'+
		'</div>';


	const settings = {
		name: 'tasearch'+ new Date().getTime(),
		displayKey: 'post_title',
		urlKey:	'permalink',
		highlight: true,
		template: template_r,
		focusClass: 'focus',
	};
	
	const fetchurl = $searchBox.data('action');
	const urlBeforeParam = fetchurl.indexOf('?') > -1 ? '&' : '?';
	const bloodhoundParams = {
		datumTokenizer: Bloodhound.tokenizers.whitespace(settings.displayKey),
		queryTokenizer: Bloodhound.tokenizers.whitespace,
		//prefetch: 'tmp/query.json',
		remote: {
			url: fetchurl + urlBeforeParam +'s=%QUERY',
			wildcard: '%QUERY'
		}
	};
	const bloodhoundSrc = new Bloodhound(bloodhoundParams);



	$searchBox[0].addEventListener('keyup', event => {
		if( event.code === 'Enter') {
			const hasFocus = $form[0].classList.contains(focusClass);
			if( hasFocus && _selected != null ) {
				document.location.href = _selected[settings.urlKey];
			}
		}
	});
	// passing in `null` for the `options` arguments will result in the default
	// options being used

	if( settings.focusClass ) {
		$searchBox.on('focus',
			() => {
				$form.addClass(settings.focusClass);
				$holder.addClass(settings.focusClass);
				$wrapper.addClass(settings.focusClass);
			}
		).on('blur',
			() => {
				$form.removeClass(settings.focusClass);
				$holder.removeClass(settings.focusClass);
				$wrapper.removeClass(settings.focusClass);
			}
		);
	}

	$searchBox.typeahead(
		{
			minLength: 2,
			highlight: settings.highlight
		},
		{
			name: settings.name,
			source: bloodhoundSrc,
			limit:10,
			displayKey: settings.displayKey,
			async: true,
			templates: {
				empty: [ '<div class="top-search-not-found">', $searchBox.data('not-found-message'), '</div>' ].join('\n'),
				pending: [ '<div class="a-spinner">', '', '</div>' ].join('\n'),
				suggestion: (s) => settings.template.replace(/\{\{([a-z_\-]+)\}\}/g, (matche, m1) => s[m1]),
				footer: [ '<div class="top-search-footer">', '', '</div>' ].join('\n'),
			}
		}
	).on('typeahead:asyncrequest',
		() => {
			$('.Typeahead-spinner').show();
		}
	)
	.on('typeahead:asynccancel typeahead:asyncreceive',
		() => {
			$('.Typeahead-spinner').hide();
		}
	)
	.on('typeahead:cursorchange',
		(event, row) => {
			_selected = row;
		}
	);
});




$.when( $.ready ).then(() => {
	init_top_search();
	
	$('.search-toggle').on('click', (e) => {
		$('.search-box, .search-input').toggleClass('active');
		$('.search-input input').focus();
		e.preventDefault();
	});
});
